import { ThirdDoorContent } from 'shared/components/ThirdDoorContent';
import { THIRD_GIFT_DOOR_LINK } from 'shared/constants/links';
import { useDoorContent } from 'shared/hooks';
import { EAdventDoorsHashs, TDoor } from 'shared/types/doors';

export const ThirdDoorContentContainer: React.FC<Omit<TDoor, 'onClickBtn'>> = props => {
  const { handleClickBtn } = useDoorContent({
    doorCode: EAdventDoorsHashs.ThirdDoor,
    giftLink: THIRD_GIFT_DOOR_LINK,
  });

  return <ThirdDoorContent onClickBtn={handleClickBtn} {...props} />;
};
